import cookie from 'cookie';
import axios from 'axios';
import { app } from './functions';
import moment from 'moment';
import { func } from 'helpers';

export const api = {
    space: process.env.space,

    api: '',
    key: '',
    platform: '',

    local: {
        key: 'PJkYEfGg9kuQIDFCRt8GU9w68RTpUUwQrCXZXzNLqK8RvY7tnW6CPtjXf2Rg9aeh',
        api: 'http://localhost/fayavotes/api/',
        platform: 'localhost',
    },
    staging: {
        key: 'PLQy96dtNIsSaZ4gFp88psVKcVW3XsnSJ2C3RThJ9F6Z2XlmAkcYQR8m1ZtwNmL3',
        api: 'https://qa-api.fayavotes.com/',
        platform: 'qa-web',
    },
    production: {
        key: 'PLQy96dtNIsSaZ4gFp88psVKcVW3XsnSJ2C3RThJ9F6Z2XlmAkcYQR8m1ZtwNmL2',
        api: 'https://api.fayavotes.com/v1/',
        api2: 'https://votes-api.anchoratechs.com/v1/',        
        platform: 'web',
    },
}

export const init = () => {
    api.api = api[api.space].api;
    api.key = api[api.space].key;
    api.platform = api[api.space].platform;
    return api;
}

export const parseCookies = (req) => {
    if (req) {
        return cookie.parse((req.headers || {}).cookie || '');
    } else {
        try {
            return cookie.parse(document.cookie);
        } catch {
            return {};
        }
    }
}

const apiHeaders = (req, type = '') => {
    const navigator = func.getCookie('fingerprint');
    const auth = {
        time: moment().unix(),
        payload: req.data,
        endpoint: req.action,
        navigator,
    };
    if (type === 'file') {
        return {
            'Accept': 'application/json',
            'Platform': `${init().platform}/${app.version}`,
            'x-access-token': `${func.encode(auth)}.`,
        };
    } else {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Platform': `${init().platform}/${app.version}`,
            'x-access-token': `${func.encode(auth)}.`,
        };
    }
}

export const apnData = (obj) => {
    const body = new FormData();
    for (var p in obj) {
        if (p === 'file') {
            body.append('file[0]', obj[p]);
        } else if (p === 'image') {
            body.append('image[0]', obj[p]);
        } else {
            body.append(p, obj[p]);
        }
    }
    return body;
}

export const post = async (action, data = {}, empty = false) => {
    let url = ((empty === false) ? init().api + action : action);
    let headers = apiHeaders({ action, data });
    try {
        let response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });
        let res = await response.json();
        return res;
    } catch (error) {
        return { status: 606, result: 'Network request failed', error };
    }
}

export const delte = async (action, data = {}, empty = false) => {
    let url = ((empty === false) ? init().api + action : action);
    let headers = apiHeaders({ action, data });
    try {
        let response = await fetch(url, {
            method: 'DELETE',
            headers,
            body: JSON.stringify(data),
        });
        let res = await response.json();
        return res;
    } catch (error) {
        return { status: 606, result: 'Network request failed', error };
    }
}

export const postFile = async (action, data = {}, empty = false) => {
    let url = ((empty === false) ? init().api + action : action);
    let headers = apiHeaders({ action, data }, 'file');
    try {
        let response = await fetch(url, {
            method: 'POST',
            headers,
            body: apnData(data)
        });
        let res = await response.json();
        return res;
    } catch (error) {
        return { status: 606, result: 'Network request failed', error };
    }
}


export const get = async (action, data = {}) => {
    let headers = apiHeaders({ action, data });
    let empty = action.includes('http:') || action.includes('https:') ? true : false;
    let url = ((empty === false) ? init().api + action : action);
    return axios({
        method: 'GET', url,
        headers: empty ? {} : headers,
        params: data,
    }).then(response => {
        const res = response.data;
        return res;
    }).catch(error => {
        return { status: 606, result: 'Network request failed', error };
    });
}

export const gets = async (action, data = {}) => {
    try {
        const response = await fetch(init().api + action, {
            method: 'POST',
            headers: api.headers
        });
        return response.json();
    }
    catch (error) {
        console.error(error);
    }
}